// Regex to match a file extension (everything after and including the last dot in a string).
export const fileExtensionRegex = /\.[^/.]+$/;
